import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarWiseGhatAmountPhineSummaryReport } from "../services/reports.services";
import { sumBy } from "lodash";

const GhatKarigarLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarWiseGhatAmountPhineSummaryReportList = useAppSelector(
    (state) => state.reports.KarigarWiseGhatAmountPhineSummaryReportList,
  );

  const isPrintAccess = checkAcessRights(
    "/ghat-karigar-ledger-report",
    PRINT_ACCESS,
  );

  const fetchKarigarWiseGhatAmountPhineSummaryReport = async (payload: any) => {
    await dispatch(getKarigarWiseGhatAmountPhineSummaryReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarWiseGhatAmountPhineSummaryReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              Ghat Karigar Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
            <Typography.h5
              style={{
                textAlign: "center",
                fontSize: "18px",
              }}
            >
              Karigar:{" "}
              {KarigarWiseGhatAmountPhineSummaryReportList?.[0]?.karigar_name}
            </Typography.h5>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarWiseGhatAmountPhineSummaryReportList &&
          KarigarWiseGhatAmountPhineSummaryReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th
                        className="col-date text-center"
                        style={{ width: "5%" }}
                      >
                        Order No
                      </th>
                      <th
                        className="col-date text-center"
                        style={{ width: "8%" }}
                      >
                        Date
                      </th>
                      <th
                        className="col-date text-center"
                        style={{ width: "8%" }}
                      >
                        Issue Date
                      </th>
                      <th className="col-desc" style={{ width: "15%" }}>
                        Particular
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Issue Weight (gm)
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Issue Phine (gm)
                      </th>
                      <th
                        className="col-receipt-amount text-end"
                        style={{ width: "8%" }}
                      >
                        Receipt Amount
                      </th>
                      <th
                        className="col-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Receipt Phine
                      </th>
                      <th
                        className="col-amount text-end"
                        style={{ width: "7%" }}
                      >
                        Amount
                      </th>
                      <th
                        className="col-phine-balance text-end"
                        style={{ width: "8%" }}
                      >
                        Phine Balance
                      </th>
                      <th
                        className="col-balance text-end"
                        style={{ width: "8%" }}
                      >
                        Balance
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {KarigarWiseGhatAmountPhineSummaryReportList.map(
                      (data, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td className="cell-date text-center">
                            {data?.OrderNo}
                          </td>
                          <td className="cell-date text-center">
                            {data?.Date}
                          </td>
                          <td className="cell-date text-center">
                            {data?.IssueDate
                              ? moment(data?.IssueDate, "YYYY-MM-DD").format(
                                  "DD/MM/YYYYś",
                                )
                              : ""}
                          </td>
                          <td
                            className="cell-desc"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {index === 0 ? `Opening Balance` : data?.item_name}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.given_weight_issue &&
                              formatWeight(data?.given_weight_issue)) ||
                              ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.phine_issue &&
                              formatWeight(data?.phine_issue)) ||
                              ""}
                          </td>
                          <td className="cell-issue">
                            {data?.amount_receipt
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.amount_receipt || 0,
                                )
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.phine_receipt &&
                              formatWeight(data?.phine_receipt)) ||
                              ""}
                          </td>
                          <td className="cell-issue">
                            {data?.amount_issue
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.amount_issue || 0,
                                )
                              : ""}
                          </td>
                          <td className="cell-receipt text-nowrap">
                            {formatWeight(data?.closing_phine)}{" "}
                            {data.creditdebittypephine === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                          <td className="cell-balance text-nowrap">
                            {formatToIndianCurrencyWithoutSymbol(
                              data?.closing_amount || 0,
                            )}{" "}
                            {data.creditdebittypeamount === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={4} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseGhatAmountPhineSummaryReportList,
                            "given_weight_issue",
                          )
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseGhatAmountPhineSummaryReportList,
                            "phine_issue",
                          )
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(
                            KarigarWiseGhatAmountPhineSummaryReportList,
                            "amount_receipt",
                          ),
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseGhatAmountPhineSummaryReportList,
                            "phine_receipt",
                          )
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          sumBy(
                            KarigarWiseGhatAmountPhineSummaryReportList,
                            "amount_issue",
                          ) || 0,
                        )}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default GhatKarigarLedgerReportView;
